
import StreetViewPanorama from '~/components/map/components/StreetViewPanorama.vue'
export default {
  components: { StreetViewPanorama },
  computed: {
    site() {
      return site
    },
    height() {
      let size = 180,
        { xs, sm, mdAndUp } = this.$vuetify.breakpoint
      if (xs) size = 180
      else if (sm) size = 190
      else if (mdAndUp) size = 260
      return size
    }
  }
}
